import React from 'react';

const NotFound = () => (
  <section className="page-section bg-surface min-h-[60vh] text-center">
    <div className="max-w-xl mx-auto">
      <p className="eyebrow">404</p>
      <h1 className="text-3xl md:text-4xl font-bold text-ink mt-2">Page not found</h1>
      <p className="page-intro mx-auto mt-5">The page you requested does not exist or may have moved.</p>
      <a href="/" className="btn-gradient mt-7">Return home</a>
    </div>
  </section>
);

export default NotFound;
